// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__lvQLK","select":"Header_select__2-_p0","clinic":"Header_clinic__2xUaP"};